import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";
import { sanitizePayload } from "../utils/sanitizer";

/**
 * Enterprise Audit Logger for CMMC Level 1, SOC 2 Type 2 & ISO 27001
 * Records immutable, timestamped audit events to the 'audit_logs' collection.
 */
export async function logSecurityEvent({
  action,
  category = "SECURITY", // "AUTH" | "ACCESS_CONTROL" | "DATA_MODIFICATION" | "ADMIN" | "INTEGRATION"
  userId = "anonymous",
  userEmail = "anonymous",
  resource = "system",
  status = "SUCCESS", // "SUCCESS" | "FAILURE" | "WARNING"
  details = {},
  severity = "INFO" // "INFO" | "LOW" | "MEDIUM" | "HIGH" | "CRITICAL"
}) {
  try {
    const rawDetails = typeof details === "object" ? details : { message: String(details) };
    const cleanDetails = sanitizePayload(rawDetails);

    const logEntry = {
      action,
      category,
      userId: userId || "anonymous",
      userEmail: userEmail || "anonymous",
      resource,
      status,
      severity,
      details: cleanDetails,
      timestamp: serverTimestamp(),
      clientTimestamp: new Date().toISOString(),
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "unknown"
    };


    // Asynchronous non-blocking write to audit_logs collection
    await addDoc(collection(db, "audit_logs"), logEntry);
  } catch (err) {
    // Non-blocking console warning so business transactions are never broken by logging failures
    console.warn("[AuditLogger] Security event dispatch notice:", err.message);
  }
}

export default {
  logSecurityEvent
};
